import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AboutPage from './pages/AboutPage';
import './App.css';

function MainApp() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Эффект для отслеживания скролла
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white overflow-hidden">
        {/* Navigation */}
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/80 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
          <div className="container mx-auto px-4 py-4 flex justify-between items-center">
            <Link to="/" className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
              MyBrand
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/about" className="hover:text-blue-400 transition-colors">
                About
              </Link>
              <a href="https://nektoman.online/forum/"  target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                Форум
              </a>
             <a href="https://nektoman.online/"  target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                Главная
              </a>
              <Link to="/contact" className="hover:text-blue-400 transition-colors">
                Contact
              </Link>
              <button className="px-5 py-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-300">
                Sign Up
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-white focus:outline-none"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-expanded={isMenuOpen}
              aria-label="Toggle menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden bg-gray-900/90 backdrop-blur-md px-4 py-4 space-y-4">
              <Link to="/about" className="block py-2 hover:text-blue-400 transition-colors" onClick={() => setIsMenuOpen(false)}>
                About
              </Link>
              <a href="https://nektoman.online/forum/"  target="_blank" rel="noopener noreferrer" className="block py-2 hover:text-blue-400 transition-colors" onClick={() => setIsMenuOpen(false)}>
                Форум
              </a>
              <a href="https://nektoman.online/"  target="_blank" rel="noopener noreferrer" className="block py-2 hover:text-blue-400 transition-colors" onClick={() => setIsMenuOpen(false)}>
                Главная
              </a>
              <Link to="/contact" className="block py-2 hover:text-blue-400 transition-colors" onClick={() => setIsMenuOpen(false)}>
                Contact
              </Link>
              <button className="w-full px-5 py-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-300">
                Sign Up
              </button>
            </div>
          )}
        </nav>

        {/* Main Content / Routes */}
        <Routes>
          <Route path="/" element={
            <section className="relative min-h-screen flex items-center pt-20 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
              {/* Ваш текущий Hero Section */}
              <div className="absolute inset-0 z-0 opacity-20">
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob"></div>
                <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"></div>
                <div className="absolute bottom-1/4 left-1/3 w-96 h-96 bg-pink-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"></div>
              </div>

              <div className="container mx-auto relative z-10 max-w-4xl">
                <div className="text-center">
                  <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold mb-6 leading-tight">
                    <span className="block">We're launching something amazing</span>
                    <span className="block bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 mt-2">
                      Coming Soon
                    </span>
                  </h1>
                  <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto">
                    We're working hard to bring you a revolutionary product. Join the waitlist to be first in line.
                  </p>
                </div>
              </div>
            </section>
          } />

          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

// Заглушка для страницы Contact
function ContactPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <h2 className="text-3xl font-bold text-white">Contact Page</h2>
    </div>
  );
}

export default MainApp;